import { TeamImportedRankingEntry } from 'models/ranking/importedRanking/entry/TeamImportedRankingEntry';

export class TeamImportedRankingEntryService {
	toModel(ranking) {
		return new TeamImportedRankingEntry(ranking);
	}
}
